import styled from 'styled-components';
import { IconClose } from '../icon/IconClose';
import { IconInfo } from '../icon/IconInfo';
import { IconButton } from '../input/IconButton';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

const Container = styled(Flex)
    .withConfig({ displayName: 'Container' })
    .attrs({
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        p: 1 / 2,
        pl: 1.5,
        width: '100%',
        borderRadius: '999px',
        wrap: 'wrap',
        spacing: 1,
    })`
    color: #ffffff;
    background-color: rgba(50, 50, 50, 0.5);
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
`;

interface SnackbarProps {
    message: string;
    onRemove: VoidFunction;
}

export const Snackbar = (props: SnackbarProps) => {
    const { message, onRemove } = props;

    return (
        <Container dataTestId={DataTestId.MESSAGE_TOAST}>
            <IconInfo size={20} />
            <Typography variant="caption" color="inherit" mr="auto">
                {message}
            </Typography>
            <IconButton size="s" onClick={onRemove}>
                <IconClose fill="#FFFFFF" />
            </IconButton>
        </Container>
    );
};
